module.exports = __webpack_public_path__ + "static/media/premierOneRightSeatTaken.25625c2b.svg";